module.exports = __webpack_public_path__ + "static/media/rose-l.e4e38c8c.svg";